import { render, staticRenderFns } from "./MotivoAnulRechGrid.vue?vue&type=template&id=b64be0d6&scoped=true&"
import script from "./MotivoAnulRechGrid.vue?vue&type=script&lang=js&"
export * from "./MotivoAnulRechGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64be0d6",
  null
  
)

/* custom blocks */
import block0 from "./MotivoAnulRechGrid.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports